import React from 'react';
const DriverOnCall = () => <div className="service-page"><h1>Driver on Call</h1><p>Hire professional drivers on call for your travel needs.</p></div>;
export default DriverOnCall;
